import { render } from "./BannerAir.vue?vue&type=template&id=7546bd87"
import script from "./BannerAir.vue?vue&type=script&lang=js"
export * from "./BannerAir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__